import type {
    IncomeSplitConfig,
    IncomeSplitRule,
} from '@fruitful/income-split';
import { MoneyMapRuleType } from '@fruitful/types';

interface IncomeSplitOverviewColorSet {
    foreground: string;
    background: string;
    backgroundPrevious: string;
    backgroundOverfund: string;
}

export const IncomeSplitOverviewColors: Record<
    MoneyMapRuleType,
    IncomeSplitOverviewColorSet
> = {
    [MoneyMapRuleType.BILLS]: {
        foreground: '$waterDarkest',
        background: '$water',
        backgroundPrevious: '$waterLight',
        backgroundOverfund: '$waterDark',
    },
    [MoneyMapRuleType.SPEND]: {
        foreground: '$leafDarkest',
        background: '$leaf',
        backgroundPrevious: '$leafLight',
        backgroundOverfund: '$leafDark',
    },
    [MoneyMapRuleType.GOAL]: {
        foreground: '$petalDarkest',
        background: '$petal',
        backgroundPrevious: '$petalLight',
        backgroundOverfund: '$petalDark',
    },
    [MoneyMapRuleType.ACCOUNT_ONLY]: {
        foreground: '#3D3D3D',
        background: '#D4D4D4',
        backgroundPrevious: '#E8E8E8',
        backgroundOverfund: '#8A8A8A',
    },
};

export interface IncomeSplitMonthlyCategoryProgress {
    percentage: number;
    cents: number;
}

export interface IncomeSplitProgress {
    bills: IncomeSplitMonthlyCategoryProgress;
    spend: IncomeSplitMonthlyCategoryProgress;
    goals: IncomeSplitMonthlyCategoryProgress;
}

export interface IncomeSplitTransferWithRuleAndHistory extends IncomeSplitTransfer {
    rule: IncomeSplitRule;
    previousTransfersForYear?: IncomeSplitTransfer[];
}

interface IncomeSplitTransferDestinationAccountDetails {
    accountNumber?: string | null;
    accountNumberMasked?: string | null;
    institutionName?: string | null;
    logo?: string | null;
    imgBase64?: string | null;
    icon?: string | null;
    color?: string | null;
}

export interface IncomeSplitTransfer {
    id: string;
    amount: number;
    ruleId: string;
    originalRuleId?: string;
    sourceAccountDisplayName: string;
    destinationAccountDisplayName: string;
    destinationAccountInstitutionName?: string | null;
    destinationAccountLogo?: string | null;
    destinationAccountImgBase64?: string | null;
    destinationAccountNumberMasked?: string | null;
    destinationAccountIcon?: string | null;
    destinationAccountColor?: string | null;
    createdAt: string;
    balanceAfterTransaction: number;
    status?: string;
    mappedStatus?: string;
    ictDepositStatus?: string;
    matchingTransfer?: {
        status?: string;
        transferPlan?: {
            destinationAccountDetails?: IncomeSplitTransferDestinationAccountDetails;
            destinationDepositoryAccountDetails?: IncomeSplitTransferDestinationAccountDetails;
            destinationInvestmentAccountDetails?: IncomeSplitTransferDestinationAccountDetails;
        };
    };
}

export interface IncomeSplitExecution {
    id: string;
    configId: string;
    description: string;
    amount: number;
    date: string;
    progress: IncomeSplitProgress;
    thisExecutionProgress?: IncomeSplitProgress;
    sourceAccountName: string;
    transfers: IncomeSplitTransfer[];
}

export interface IncomeSplitOverviewHistory {
    month: string;
    executions: IncomeSplitExecution[];
    progress: IncomeSplitProgress | null;
}

export interface IncomeSplitOverviewData {
    configs: IncomeSplitConfig[];
    history: IncomeSplitOverviewHistory[];
}
